import SettingsTheme from "@/views/admin/settings/Theme";

export default {
  path: "settings/theme",
  name: "settings-theme",
  component: SettingsTheme,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
